import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import ReactEcharts from "echarts-for-react";
import { useTranslation } from "react-i18next";

import {
  selectCategory,
  selectYear,
  selectMonth,
  selectDay,
  selectTemperaturePoint,
} from "@/selector";
import {
  getDefaultYear,
  getDefaultMonth,
  getDefaultDay,
  promiseDispatch,
} from "@/util";
import { actionCreators } from "@/duck/dashboard";

const Temperature = () => {
  const { t } = useTranslation();
  const { innerWidth } = window;
  const fontSize = innerWidth > 4000 ? 24 : 12;
  const [temperature, setTemperature] = useState();
  const dispatch = useDispatch();
  const category = useSelector(selectCategory);
  const year =
    useSelector(selectYear) || getDefaultYear(category);
  const month =
    useSelector(selectMonth) ||
    getDefaultMonth(category);
  const day =
    useSelector(selectDay) ||
    getDefaultDay();
  const temperaturePoint = useSelector(selectTemperaturePoint);

  useEffect(() => {
    if (category === "history" && temperaturePoint) {
      promiseDispatch(
        dispatch,
        actionCreators.dashboard.panel.query.temperature,
        { date: `${year}-${month}-${day}`, point: temperaturePoint }
      ).then((response) => {
        if (response) {
          if (response.status === "OK") {
            console.log(response.msg)
            setTemperature(response.msg);
          }
        }
      });
    }
  }, [dispatch, category, year, month, day, temperaturePoint]);
  if (category !== "history") {
    return <div>{t("temperature.empty")}</div>;
  }
  if (!temperature) return <div>{t("temperature.default")}</div>;

  const dates = temperature.map((t) => t.date);
  const value = temperature.map((t) => t.temperature);

  return (
    <ReactEcharts
      option={{
        xAxis: {
          type: "category",
          data: dates,
          axisLabel: {
            color: "rgba(255,255,255,0.75)",
            fontSize: fontSize,
            lineHeight: 16,
            end: true,
            margin: 10,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "rgba(255, 255, 255, 0.75)",
            },
          },
          axisTick: {
            show: true,
            alignWithLabel: true,
            lineStyle: {
              color: "rgba(255, 255, 255, 0.75)",
            },
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            color: "rgba(255,255,255,0.75)",
            fontSize: fontSize,
            lineHeight: 16,
            end: true,
            margin: 10,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "rgba(255, 255, 255, 0.75)",
            },
          },
          axisTick: {
            show: true,
            lineStyle: {
              color: "rgba(255, 255, 255, 0.75)",
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "rgba(255, 255, 255, 0.35)",
            },
          },
        },
        series: [
          {
            data: value,
            type: "line",
          },
        ],
        color: "#ffc53d",
        grid: {
          left: "30",
          right: "20",
          bottom: "30",
          top: "5",
        },
        tooltip: {
          show: true,
        },
      }}
      style={{ height: "100%", width: "100%" }}
    />
  );
};

export default Temperature;
